import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { PoemContext } from './App';
import axios from 'axios';

function Home() {
  let history = useHistory();
  const [poem, setPoem] = useContext(PoemContext);
  const [inputSent, setInputSent] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  const [message, setMessage] = useState("");

  function handleInputChange(e) {
    setInputSent(e.target.value);
  };

  function handleSubmit() {
    console.log(inputSent);
    if (inputSent.length > 8) {
      // no more than 15 characters
      setMessage("抱歉，请您输入不要超过8个字");
    } else if (showMsg===true && message==="请您稍等...") {console.log("防止连按")} else {
      setShowMsg(true);
      setMessage("请您稍等...");
      // send input Couplet to server
      var data_first_sent = {
        'poem': inputSent
      };
      axios.post(process.env.REACT_APP_BACKEND_IP + '/getsrc', JSON.stringify(data_first_sent))
        .then(function (response) {
            // console.log(response);
            // success get poem id
            var code = response.data.code;
            var celery_id = response.data.celery_id;
            if (code === '0') {
              var data_celery_id = {
                'celery_id': celery_id
              };
              // var cnt = 0;
              var a = setInterval(function() {
                axios.post(process.env.REACT_APP_BACKEND_IP + '/sendsrc', JSON.stringify(data_celery_id))
                  .then(function (response) {
                    // cnt += 1;
                    // if (cnt > 60) {
                    //   setMessage("抱歉，对您出的首句，我江郎才尽了。您可另出一首句");
                    //   clearInterval(a);
                    // }
                    // success get poem
                    var status = response.data.status;
                    var sens = response.data.sens;
                    var sources = response.data.source;
                    var source_content = response.data.sourcecontent;
                    var score = response.data.score;
                    if (status === 'SUCCESS') {
                      setPoem({
                        'input': inputSent,
                        'sents': sens, 
                        'srcs': sources,
                        'src_content': source_content,
                        'score': score
                      });
                      console.log(poem);
                      setShowMsg(false);
                      clearInterval(a);
                      history.replace('/ShowResult');
                    } else if (status === 'FAILED') {
                      // failed to get poem
                      setMessage("抱歉，对您出的目标句，我江郎才尽了。您可另出一句");
                      clearInterval(a);
                    } else if (status === 'NOOUTPUT') {
                      // failed to get poem
                      setMessage("抱歉，对您出的目标句，我江郎才尽了。您可另出一句");
                      clearInterval(a);
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    // get couplet failed
                    setMessage("出错了，请重试...");
                    clearInterval(a);
                  })
              }, 500);
            } else {
              // input error
              setMessage("出错了，请重试...");
            }
        })
        .catch(function (error) { 
            console.log(error);
            // getCouplet id failed
            setMessage("服务维护请稍后再试...");
        })
    }
  };
  function scrollWindow() {
    console.log("onBlur");
    window.scrollTo(0, 0);
  };
  
  const inputEle = (
      <div className="container h-4/5 mx-auto flex grid gap-5 place-content-center">
        <div className="relative place-self-center">
          <img className="inline w-28 h-28 md:w-52 md:h-52" src="../souqi/images/aiJiugeLogo.png" alt="" />
          &nbsp;&nbsp;
          <img className="inline w-32 h-16 md:w-60 md:h-32" src="../souqi/images/jiugeSearchLogo.png" alt="" />
        </div>
          <h1 className="text-xl md:text-3xl text-purple-800 place-self-center">请输入不超过8字的诗句:</h1>
          <input className="w-11/12 shadow appearance-none border rounded w-full text-xl py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
              id="username" type="text" placeholder="请输入不超过8字的诗句" onChange={e => handleInputChange(e)} onBlur={scrollWindow} />
          <button className="w-11/12 place-self-center bg-purple-500 text-white font-bold py-2 px-4 text-xl rounded-2xl focus:outline-none" onClick={handleSubmit}>
              <span className="inline">搜类义句</span> <img className="inline w-6 h-6" src="../souqi/images/hand-point-up.png" alt=""/>
          </button>
          <h1 className="text-center w-10/12 text-2xl text-purple-800 place-self-center" hidden={!showMsg}>{message}</h1>
      </div>
  );
  const footer = (
    <div>
      <div style={{'maxHeight': '20vh'}} className="fixed inset-x-0 bottom-0 text-center h-auto text-base md:text-2xl bg-white p-3 md:p-5">
          <p>清华大学</p>
          <p>自然语言处理实验室</p>
          <p>九歌: <a href="http://jiuge.thunlp.org">jiuge.thunlp.org</a></p>
      </div>
      <img className="fixed bottom-2 md:bottom-4 left-1 w-20 h-20 md:w-28 md:h-28" src="../souqi/images/qrJiuge.png" alt='九歌二维码'/>
      <img className="fixed bottom-2 md:bottom-4 right-1 w-20 h-20 md:w-28 md:h-28" src="../souqi/images/qrTHUNLP.jpg" alt='THUNLP公众号二维码' />
    </div>
  );

  return (
      <div className="w-screen mx-auto h-screen bg-purple-100" style={{background: "url('../souqi/images/qianlijiangshan.png') no-repeat center center", backgroundSize: "cover"}}>
        <div className="w-full h-full bg-purple-100 bg-opacity-70">
          {inputEle}
          {footer}
        </div>
      </div>
  )
};

export default Home;